import React from "react";

import CustomParser from "modules/CustomParser";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { makeStyles } from "tss-react/mui";

import { TeamMember } from "components/TeamMember/TeamMember.js";

import {
  innerTitle,
  zeroPadding,
} from "../../assets/jss/nextjs-material-kit-pro";

const useStyles = makeStyles()({
  innerTitle,
  zeroPadding,
  team: {
    paddingBottom: "30px",
  },
});

export default function SectionTeam(props) {
  const { team } = props;

  const { classes } = useStyles();
  return (
    <div className={classes.team}>
      {team.teamTitle && (
        <h2 className={classes.innerTitle}>{team.teamTitle}</h2>
      )}
      <div>
        <CustomParser content={team.description} />
      </div>
      {team.members.map((mem) =>
        mem.member ? (
          <TeamMember member={mem.member} showRole key={mem.member.id} />
        ) : null
      )}
    </div>
  );
}
